const ClaimTypeStyles = {
  container: {
    p: 3,
  },
  title: {
    mb: 3,
    fontFamily: 'var(--font-noto-sans)',
  },
  card: (selected: boolean) => ({
    cursor: 'pointer',
    height: '100%',
    transition: 'all 0.3s ease',
    border: selected ? '2px solid #2196f3' : '1px solid #e0e0e0',
    boxShadow: selected
      ? '0 4px 12px rgba(33, 150, 243, 0.2)'
      : '0 2px 4px rgba(0,0,0,0.1)',
    '&:hover': {
      transform: 'translateY(-4px)',
      boxShadow: '0 6px 12px rgba(0,0,0,0.1)',
      borderColor: '#2196f3',
    },
  }),
  cardContent: {
    p: 4,
  },
  iconBox: (selected: boolean) => ({
    display: 'flex',
    alignItems: 'center',
    mb: 2,
    color: selected ? '#2196f3' : '#666',
  }),
  claimTypeText: {
    fontWeight: 500,
    fontFamily: 'var(--font-noto-sans)',
  },
  description: {
    minHeight: 48,
    fontFamily: 'var(--font-noto-sans)',
  },
  selectedBox: {
    mt: 2,
    p: 1,
    bgcolor: 'rgba(33, 150, 243, 0.08)',
    borderRadius: 1,
    display: 'flex',
    alignItems: 'center',
  },
  selectedText: {
    fontFamily: 'var(--font-noto-sans)',
  },
};

export default ClaimTypeStyles; 